<template>
  <base-display-widget :iteminfo="iteminfo" class="bg-white" style="width: 373px;"
                       v-bind="$attrs"
                       v-on="$listeners">
    <div class="flex a-center b-b bg-white p-h-15" style="height: 50px"
         v-if="iteminfo.config.menutitle && iteminfo.config.menutitle.length">
      <span :style="{color:getTitleColor}"
            class="fs-14 bold">{{ iteminfo.config.menutitle || '论坛标题' }}</span>
      <div class="flex-1">
      </div>
      <div v-if="getShowMore">
        更多>
      </div>
    </div>
    <ul class="ul-style">
      <li :key="index" class="item-style" v-for="(item,index) in gettemplist">
        <div class="text-left fs-14 p-h-10 p-b-5">
          <div class="flex a-top p-t-10">
            <img :src="  getUserImg(item)" alt="" class="b-round m-r-5 flex-s-0"
                 style="width: 44px;height: 44px">
            <div class="flex-1 m-l-5 p-t-5">
              <div v-if="getUserName(item)">
                <div>{{getUserName(item)}}</div>
                <div>{{item.publishTime}}</div>
              </div>
              <img class="w-full" src="../../../assets/common/ic_text_sec.png" v-if="!getUserName(item)">
            </div>
          </div>
          <div :style="{paddingLeft:getLeftPadding}">
            <div class="m-v-5 bold" v-html="item.title" v-if="item.title"></div>
            <div class="m-v-5 bold" v-html="item.content" v-if="item.content"></div>
            <div class="relative left-0 top-0" v-if="getShowVideoPic(item)">
              <img :src="getShowVideoPic(item)" alt="" class="w-full">
              <div class="w-full  h-full absolute top-0 flex a-center j-center w-full h-full">
                <img class="w-40 h-40" src="../../../assets/common/ic_shipin_play.png">
              </div>
            </div>
            <ul class="flex flex-wrap" v-if="item.imgList && item.imgList.length>0">
              <li :class="{'w-p-50':item.imgList.length>1,'w-full':item.imgList.length === 1}" :key="index_child"
                  class=" p-4 fs-s-0"
                  v-for="(item_child,index_child) in item.imgList.slice(0,2)">
                <ratio-div :RadioValue="82" v-if="item.imgList.length>1">
                  <div class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                       style="background: #F8F8F9">
                    <img :src="getShowImg(item_child)" alt="" class="w-full h-full" v-if="item_child.imgUrl">
                    <img alt="" class="w-30 h-30" src="../../../assets/common/ic_picture_center.png"
                         v-if="!item_child.imgUrl">
                    <div class="absolute w-full h-full left-0 top-0 flex a-center j-center fs-30 bold text-white"
                         style="background: #00000040"
                         v-if="item.imgList.length>2 && index_child===1">
                      <span>+</span> <span class="m-l-5">{{item.imgList.length-2}}</span>
                    </div>
                  </div>
                </ratio-div>
                <ratio-div :RadioValue="56" v-if="item.imgList.length === 1">
                  <div class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                       style="background: #F8F8F9">
                    <img :src="getShowImg(item_child)" alt="" class="w-full h-full">
                  </div>
                </ratio-div>
              </li>
            </ul>
            <img class="w-full m-t-10" src="../../../assets/common/ic_text_thr.png" v-if="!item.content">
          </div>
        </div>
      </li>
    </ul>

  </base-display-widget>
</template>

<script>
// import WidgetPlugn from './WidgetPlugn'
import RatioDiv from '../../common/RatioDiv'
import baseDisplayWidget from '@/components/widget/base/BaseDisplayWidget'
import {mapActions} from 'vuex'
import Bus from '@/utils/bus'
import {parseUrl} from '@/utils/UrlFormat'

export default {
  name: 'DynamicWidget',
  components: {RatioDiv, baseDisplayWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      linkDataList: [],
      total: 0,
      fileUpdate: null
    }
  },
  watch: {
    getContent: {
      handler (newValue) {
        this.getDataShow()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    getShowMore () {
      let show = false
      let hasLimit = this.iteminfo.config.haslimit
      let showNum = parseInt(this.iteminfo.config.showNum || 1)
      if (hasLimit === 1 && this.total > showNum) {
        show = true
      }
      return show
    },
    getContent () {
      return {
        linkUrl: this.iteminfo.config.jumpObj.linkUrl,
        showNum: this.iteminfo.config.showNum,
        haslimit: this.iteminfo.config.haslimit,
      }
    },
    gettemplist () {
      if (this.iteminfo.config.jumpObj.linkUrl) {
        return this.getshowDataList(this.linkDataList)
      } else {
        return this.getDefaultBBSList()
      }
    },
    getLeftPadding () {
      if (this.iteminfo.config.displayType === 1) {
        return '50px'
      }
      return '0px'
    },
    getTitleColor () {
      return this.iteminfo.config.titleColor || '#333333'
    }
  },
  mounted () {
    this.init()
  },
  destroyed () {
    Bus.$off('dynamicChange', this.fileUpdate)
  },
  methods: {
    init () {
      this.fileUpdate = this.getDataShow
      Bus.$on('dynamicChange', this.fileUpdate)
    },
    getDataShow () {
      if (this.iteminfo.config.jumpObj.linkUrl) {
        this.getBBSLists()
      } else {
        this.linkDataList = this.getDefaultBBSList()
      }
    },
    ondel () {
      this.$emit('ondel')
    },
    getshowDataList (list) {
      let templist = []
      templist = (list && list.length) ? list : this.getDefaultBBSList()
      return templist

    },
    getDefaultBBSList () {
      let templist = []
      let length = 2
      for (let i = 0; i < length; i++) {
        templist.push({
          imgList: [{}, {}],
        })
      }
      return templist
    },
    getBBSLists () {
      let url = this.iteminfo.config.jumpObj.linkUrl
      let par = parseUrl(url)
      if (par.contentType && parseInt(par.contentType) === 91 || parseInt(par.contentType) === 92) {
        let goodsId = par.goodsId || ''
        let pageSize = 20
        if (this.iteminfo.config.haslimit === 1 && parseInt(this.iteminfo.config.showNum) > 0) {
          pageSize = parseInt(this.iteminfo.config.showNum)
        }
        let params = {
          // entId: parseInt(par.entId),
          pageNum: 1,
          pageSize: pageSize
        }
        if (goodsId) {
          params.goodsId = goodsId
        }
        let strId = par.id.replace(',', '')
        let id = parseInt(strId) || 0
        switch (parseInt(par.contentType)) {
          case 91:
            params.categoryId = id
            break
          case 92:
            params.groupId = id
            break
        }
        this.getBbs(params).then(res => {
          if (res.code === 0) {
            this.linkDataList = res.data.list
            if (this.linkDataList && this.linkDataList.length < 1) {
              this.linkDataList = this.getDefaultBBSList()
            }
            this.total = res.data.total || 0
          }
        })
      } else if (par.contentType && parseInt(par.contentType) === 93) {
        let id = parseInt(par.id) || 0
        if (id) {
          let params = {}
          this.getbbsDetail({
            id,
            params
          }).then(res => {
            if (res.code === 0) {
              let data = res.data
              let videoList = data.videoList || []

              this.linkDataList = [{
                id: data.id,
                categoryName: (data.category && data.category.name) ? data.category.name : '',
                groupName: (data.group && data.group.name) ? data.group.name : '',
                title: data.title || '',
                content: data.content || '',
                imgCount: (data.imgList && data.imgList.length) ? data.imgList.length : 0,
                imgList: data.imgList || [],
                videoList: videoList,
                publishTime: data.publishTime ? new Date(data.publishTime).format('yyyy-MM-dd') : '',
                user: data.user || {name: ''}
              }]
            }
          })
        } else {
          this.linkDataList = this.getDefaultBBSList()
        }
      } else {
        this.linkDataList = this.getDefaultBBSList()
      }
    },
    getUserImg (item) {
      if (item && item.user && item.user.icon) {
        return item.user.icon
      }
      return require('../../../assets/common/ic_head_portrait.png')
    },
    getUserName (item) {
      if (item && item.user && item.user.name) {
        return item.user.name
      }
      return ''
    },
    getShowImg (item) {
      if (item.imgUrl) {
        return item.imgUrl
      }
      return require('../../../assets/common/ic_picture_center.png')
    },
    getShowVideoPic (item) {
      let videoCover = ''
      if (item.videoList && item.videoList.length) {
        let videoItem = item.videoList[0]
        if (videoItem.imgUrl) {
          return videoItem.imgUrl
        }
        if (videoItem.videoUrl) {
          return videoItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,ar_auto'
        }
      }
      return videoCover
    },
    ...mapActions([
      'getBbs',
      'getbbsDetail',
      'delBbs'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .item-style {
    border-bottom: 1px solid #dcdfe6;
  }

  .ul-style:last-child {
    border-bottom: none
  }
</style>
